import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Dimensions,
  Image,
  TouchableOpacity,
  FlatList,
  ScrollView,
} from "react-native";
import React, { useState } from "react";

// import { useTranslation } from "react-i18next";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import { Notify } from "../../Constants/Data";
const { height, width } = Dimensions.get("window");

const Notifi = ({ navigation }) => {
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  return (
    <SafeAreaView style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
      <View
        style={{
          width: "100%",

          flexDirection: "row",

          alignItems: "center",

          backgroundColor: AppColors.white,

          height: 58,

          justifyContent: "space-between",

          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{ height: 30, width: 30, justifyContent: "center" }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>

          <Text
            style={{
              color: AppColors.brown1,

              fontSize: 16,

              fontFamily: AppFonts.OverpassMedium,
            }}
          >
            Notifications
          </Text>
        </View>
      </View>
      <ScrollView>
        <View
          style={{
            backgroundColor: AppColors.white,
            marginTop: 20,
            padding: 20,
          }}
        >
          <FlatList
            data={Notify}
            showsVerticalScrollIndicator={false}
            ItemSeparatorComponent={() => (
              // <View
              //   style={{
              //     width: 2,
              //     height: 50,
              //     marginLeft: 22,
              //     marginTop: -10,
              //     flexDirection: "column",
              //     borderStyle: "dotted",
              //   }}
              // >
              //   <View
              //     style={{
              //       flex: 1,
              //       backgroundColor: "#9C4900",
              //       width: 1,
              //     }}
              //   />
              // </View>
              <View>
                <Image
                  source={AppImages.lineNoti}
                  style={{ height: 30, width: 2, marginLeft: 22 }}
                />
              </View>
            )}
            renderItem={({ item }) => (
              <TouchableOpacity
                onPress={() => navigation.navigate("UsersAdministartionView")}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingVertical: 10,
                  }}
                >
                  <View style={{ flexDirection: "row", flex: 1 }}>
                    <Image
                      source={item.img1}
                      style={{ width: 48, height: 48 }}
                    />
                    <View style={{ marginLeft: 20, flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassBold,
                          color: AppColors.brown1,
                          width: "96%",
                        }}
                      >
                        {item.day}
                      </Text>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                          color: AppColors.brown1,
                          width: "96%",
                        }}
                      >
                        {item.msg}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      backgroundColor: "#F6EDE6",
                      borderRadius: 10,
                      height: 30,

                      alignItems: "center",
                      justifyContent: "center",
                      paddingHorizontal: 8,
                    }}
                  >
                    <Text
                      style={{
                        color: "#421F00",
                        fontSize: 10,
                        fontFamily: AppFonts.OverpassSemiBold,
                      }}
                    >
                      {item.tym}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            )}
          ></FlatList>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default Notifi;

const styles = StyleSheet.create({});
